export default __webpack_public_path__ + "static/media/brandstof_gtl.be67ac3c.svg";